<mojo-candidate-side-nav-container
  *ngIf="disableNavigation && sidebarOpened"
  [selectedCandidate]="candidate"
  [sideDrawerCandidatesList]="sideDrawerCandidatesList"
  [fromDashboardLanding]="fromDashboardLanding"
  [sidebarOpened]="sidebarOpened"
  [jobId]="jobId"
  [talentPoolId]="talentPoolSideDrawerSelectedId"
  (closeEmitter)="sideNavAction()"
  [fromTalentPool]="fromTalentPool"
>
</mojo-candidate-side-nav-container>

<div
  (click)="sideNavAction()"
  class="position-relative clickable"
>

  <common-mojo-card
    *ngIf="displayCandidateCardArea; else candidateAreaHiddenView"
    data-cy="common-mojo-card"
    #card
  >
    <ng-container [ngTemplateOutlet]="candidateView"></ng-container>
  </common-mojo-card>

  <ng-template #candidateAreaHiddenView>
    <ng-container [ngTemplateOutlet]="candidateView"></ng-container>
  </ng-template>
</div>

<ng-template #candidateView>
  <div
    *ngIf="enableSelection && (isMobileViewService.isMobileView$() | async)
      === false"
    #batchItemSelector="mojoBatchItemSelector"
    (click)="$event.stopPropagation()"
    [mojoBatchItemSelector]="candidate.id"
    class="batch-item-selector"
    [class.selected]="(batchItemSelector.isSelected$ | async) === true"
  >
    <mat-checkbox #batchItemSelectorCheckbox></mat-checkbox>
  </div>
  <div
    [ngClass]="displayCandidateCardArea ? 'candidate-area-wrapper' : 'without-area'"
  >
    <div class="position-relative">
      <div
        class="labels-mobile"
        *ngIf="isMobileViewService.isMobileView$() | async"
      >
        <mojo-candidate-badges
          [favorite]="candidate.favorite"
          [silver]="candidate.silver"
          [alumni]="candidate.alumni"
          [warning]="candidate.warning"
          [inline]="true"
        >
        </mojo-candidate-badges>
        <ng-content
          select="card-header-mobile"
          (click)="$event?.stopPropagation()"
        ></ng-content>
      </div>
      <div class="main-wrapper">
        <div
          class="candidate-profile"
          [class.align-items-center]="centerContent"
        >
          <div
            class="selectable"
            *ngIf="selectable"
          >
            <mat-radio-button
              (change)="selectCandidateCard(candidate.id)"
              data-cy="candidate-selection-button"
            >
            </mat-radio-button>
          </div>
          <ng-container
            *mojoHasPrivilege="candidateViewPrivilege; else withoutNavigationView"
          >
            <a
              *ngIf="!disableNavigation; else disableAvatarNavigation"
              [routerLink]="inModal ? [{outlets: { primary: ['candidates',
              candidate?.id], modal: null}}] : ['/candidates', candidate?.id]"
              class="avatar"
            >
              <common-mojo-avatar
                [id]="candidate.candidateImageId"
                [initials]="candidate.initials"
                [selectedPhotoShape]="avatarPhotoShape"
                [label]="candidate.label"
                [showLabel]="showAvatarLabel"
                [backgroundSize]="avatarBackground"
                (click)="$event.stopPropagation()"
                data-cy="candidate-avatar"
              >
              </common-mojo-avatar>
            </a>
            <ng-template #disableAvatarNavigation>
              <common-mojo-avatar
                [id]="candidate.candidateImageId"
                [initials]="candidate.initials"
                [selectedPhotoShape]="avatarPhotoShape"
                [label]="candidate.label"
                [showLabel]="showAvatarLabel"
                [backgroundSize]="avatarBackground"
              ></common-mojo-avatar>
            </ng-template>
          </ng-container>
          <ng-template #withoutNavigationView>
            <common-mojo-avatar
              [id]="candidate.candidateImageId"
              [initials]="candidate.initials"
              [selectedPhotoShape]="avatarPhotoShape"
              [label]="candidate.label"
              [showLabel]="showAvatarLabel"
              [backgroundSize]="avatarBackground"
              (click)="$event.stopPropagation()"
              data-cy="candidate-avatar"
            >
            </common-mojo-avatar>
          </ng-template>

          <div class="description">
            <div
              class="labels-desktop"
              *ngIf="showLabels"
            >
              <mojo-candidate-badges
                [favorite]="candidate.favorite"
                [silver]="candidate.silver"
                [alumni]="candidate.alumni"
                [warning]="candidate.warning"
                [inline]="true"
              >
              </mojo-candidate-badges>
              <ng-content select="card-header"></ng-content>
            </div>
            <div class="d-flex justify-content-between">
              <div
                *ngIf="disableNavigation; else nameWithNavigation"
                class="name-with-socials"
              >
                <p
                  [ngClass]="{'marked-text': (candidate?.id === (sideDrawerCandidateId$ | async))}"
                  class="mat-body-1 candidate-name"
                >
                  {{candidate?.visibleName}}
                </p>
                <ng-container [ngTemplateOutlet]="socialLinks"></ng-container>
              </div>
            </div>
            <ng-template #nameWithNavigation>
              <div
                (click)="$event?.stopPropagation()"
                class="name-with-socials"
              >
                <ng-container
                  *mojoHasPrivilege="candidateViewPrivilege; else withoutNavigationNameView"
                >
                  <a
                    [routerLink]="inModal ? [{outlets: { primary: ['candidates',
                  candidate?.id], modal: null}}] : ['/candidates',
                  candidate?.id, 'details']"
                    class="mat-body-1 candidate-name"
                    data-cy="candidate-card-visible-name"
                  >{{
                    candidate?.visibleName }}</a>
                </ng-container>
                <ng-template #withoutNavigationNameView>
                  <p class="mat-body-1">{{candidate?.visibleName}}</p>
                </ng-template>
                <ng-container [ngTemplateOutlet]="socialLinks"></ng-container>
              </div>
            </ng-template>

            <div class="experience-address">
              <mojo-candidate-experience
                class="card-element mat-body"
                [flexLayout]="(isMobileViewService.isMobileView$() | async)
                  === false"
                [class.no-labels]="!showLabels"
                [candidate]="candidate"
              >
              </mojo-candidate-experience>
              <mojo-candidate-address
                class="card-element mat-body grayed"
                *ngIf="candidate?.addressLong"
                [address]="(isMobileViewService.isMobileView$() | async)
                  ? getMobileAddress(candidate)
                  : candidate?.addressLong"
              >
              </mojo-candidate-address>
            </div>

            <mojo-candidate-contact
              *ngIf="candidateContact"
              [candidate]="candidate"
              [hideResumeDownloadButton]="hideResumeDownloadButton"
              [includeContactButtons]="isNotHiringManager$ | async"
              [includeResumeButton]="!(isNotHiringManager$ | async)"
              [showQA]="showQA"
              class="card-element mat-body"
              (click)="$event?.stopPropagation()"
            >
            </mojo-candidate-contact>
            <div
              (click)="$event.stopPropagation()"
              class="description-footer card-element mat-body"
            >
              <ng-content select="[card-description-footer]"></ng-content>
            </div>
          </div>
        </div>
        <div
          class="bottom-right-block"
          [ngClass]="{'lower-bottom-right-block' : hasStatus}"
          *ngIf="!selectable"
        >
          <div
            class="candidate-date mat-body"
            matTooltip="{{getDateLabel()}} {{getDate() | date: 'MM/dd/yy'}}"
          >
            {{getDate() | date: 'MM/dd/yy'}}
          </div>
        </div>
        <div class="footer">
          <ng-content
            select="[card-footer]"
            (click)="$event?.stopPropagation()"
          ></ng-content>
        </div>
      </div>
      <div class="aside">
        <ng-content
          select="aside"
          (click)="$event?.stopPropagation()"
        ></ng-content>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #socialLinks>
  <mojo-social-links
    (click)="$event?.stopPropagation()"
    [candidate]="candidate"
    [inline]="true"
    [mini]="true"
    *ngIf="candidate?.isNotAnonymized"
  >
    <mojo-ats-button
      [entity]="candidate"
      [type]="candidateAtsButtonType"
      [mini]="true"
    ></mojo-ats-button>
  </mojo-social-links>
</ng-template>
